import { routes } from "consts";
import React from "react";
import { ChangelogArticle, ChangelogBody, LinkTo } from "../components";

export const Article20240909 = (): JSX.Element | null => {
  return (
    <ChangelogArticle date="9 Wrzesień, 2024" header="Patch 1.0.2" labels={["bugfix"]}>
      <ChangelogBody title="1. Ankiety - poprawa filtrowania i sortowania">
        Na ekranie <LinkTo to={routes.SURVEYS}>Ankiety</LinkTo> zostało poprawione sortowanie i filtrowanie ankiet.
        <br /> Ekran wspiera wyszukiwanie po nazwie ankiety oraz sortowanie po nazwie oraz dacie dodania.
      </ChangelogBody>
    </ChangelogArticle>
  );
};
